import angular from 'angular';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';
///
/// This state displays SOPs that the user can see
///

angular.module('flowingly.runner.procedures').config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state(STATE_MAPPINGS.procedures, {
    url: 'sops',
    params: { title: 'Standard Operating Procedures', backFromState: '' },
    controller: [
      '$stateParams',
      function ($stateParams) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const $ctrl = this;
        $ctrl.backFromState = $stateParams.backFromState;
      }
    ],
    controllerAs: '$ctrl',
    template: '<procedures back-from-state="$ctrl.backFromState"></procedures>'
  });
}
